import { jsx as _jsx } from "react/jsx-runtime";
// AdSlot.tsx
import { useBrand } from '@aviv-unified-frontend/runtime/brand';
import { Box } from '@gemini/core';
import { isMobile } from 'mobile-device-detect';
import { useRef } from 'react';
import { useAdsContext, useAdSlots } from '../../contexts/AdsContext';
import { useAdImageDimensions } from '../../hooks/useAdImageDimensions';
import useLoadAd from '../../hooks/useLoadAd';
import { useProgrammaticAdDetection } from '../../hooks/useProgrammaticAdDetection';
import { findSlot } from './findSlot';
import { getAdSlotDistributionType } from './getAdSlotDistributionType';
const AdSlot = ({ slot: slotName, placeholderPosition = 'initial' }) => {
    const { adsEnabled, searchModel } = useAdsContext();
    const adSlots = useAdSlots();
    const { createUrl } = useBrand();
    const adRef = useRef(null);
    if (!searchModel)
        return null;
    const slotConfig = findSlot({
        adSlots,
        slotName,
        distributionType: getAdSlotDistributionType(searchModel),
    });
    const adHasLoaded = slotConfig && useLoadAd(slotConfig);
    // Only run detection for the mastHead slot
    const isProgrammatic = useProgrammaticAdDetection(adRef, !!adHasLoaded && slotName === 'mastHead');
    const maxWidth = isProgrammatic ? slotConfig?.placeholderMaxWidth : '100%';
    // Calculate ad height for skyscraper and skyscraperTop slots
    const adHeight = slotName === 'skyscraper' || slotName === 'skyscraperTop' ? useAdImageDimensions(adRef, !!adHasLoaded) : undefined;
    return (slotConfig &&
        adsEnabled && (_jsx(Box, { ref: adRef, id: slotConfig.id, textAlign: "center", testId: slotConfig.testId, maxWidth: maxWidth, width: isMobile ? slotConfig.placeholderWidthMobile : slotConfig.placeholderWidth, height: adHeight || (isMobile ? slotConfig.placeholderHeightMobile : slotConfig.placeholderHeight), backgroundColor: adHasLoaded ? undefined : 'color.background.light', position: placeholderPosition, top: slotConfig.placeholderTop, marginVertical: slotConfig.marginVertical, marginHorizontal: slotConfig.marginHorizontal, backgroundImage: slotConfig.backgroundImage ? `url(${createUrl(slotConfig.backgroundImage)})` : undefined, backgroundPosition: slotConfig.backgroundPosition || undefined })));
};
export default AdSlot;
